export const FILE_HOST = import.meta.env.VITE_APP_FILE_HOST;

export const CANCELLATION_POLICY_LINK = `${FILE_HOST}/cancellation-policy`;
